module.exports = __webpack_public_path__ + "img/sankaku_73_red.e0338d76.png";